// Agregá nuevos avisos al principio o al final de este listado.
// Cada aviso admite: id, title, message, icon, pack y color.
export default [
  {
    id: "crm-email-signature",
    title: "Actualizá la firma de tu email",
    message:
      "Hemos rediseñado la <strong>firma de email</strong> para que acompañe la identidad visual de OSFATUN.",
    icon: "signature",
    pack: "fas",
    color: "#02758f",
    action: "profile",
  },
  {
    id: "crm-visual-refresh",
    title: "Nueva estética y nuevas vistas",
    message:
      "Hemos realizado modificaciones visuales para <strong>modernizar el CRM</strong>. Esperamos que te gusten. Si tenés algún inconveniente con esta nueva versión, comunicate con el <strong>Dpto. de Sistemas</strong> para ser asesorado o presentar reclamos.",
    icon: "palette",
    pack: "fas",
    color: "#02758f",
  },
  {
    id: "crm-new-menu",
    title: "Nuevo menú",
    message:
      "En esta nueva versión, agrupamos distintas funciones y accesos dentro de <strong>menús más abarcativos</strong>. Al hacer clic en cada uno, podrás ver más accesos según los permisos asignados. Además, seguimos mejorando la visualización desde el celular.",
    icon: "columns",
    pack: "fas",
    color: "#168ca4",
  },
  {
    id: "crm-plans-menu",
    title: "Nuevo menú Planes",
    message:
      "Dentro de este menú se podrán ver y administrar <strong>todos los planes</strong> y los montos de cuotas y mínimos.",
    iconImage: "/img/sidebar/planes.svg",
    color: "#02758f",
    permission: "cuotasyminimos.ver",
  },
  {
    id: "crm-providers-menu",
    title: "Nuevo menú Prestadores",
    message:
      "Al hacer clic en Prestadores se desplegarán opciones internas como el listado de <strong>facturación</strong>, el listado de prestadores y el acceso al vademécum de la web.",
    iconImage: "/img/sidebar/prestaciones.svg",
    color: "#168ca4",
    permission: "prestadores.ver",
  },
  {
    id: "crm-organization-menu",
    title: "Nuevo menú Organización",
    message:
      "Dentro de este menú encontrarás lo relacionado a los <strong>RR. HH.</strong> y las Delegaciones de OSFATUN y su gestión. Dentro de Departamentos, podrás asignar los permisos correspondientes.",
    iconImage: "/img/sidebar/organizacion.svg",
    color: "#02758f",
    anyPermissions: ["agentes.ver", "delegaciones.ver", "departamentos.ver"],
  },
  {
    id: "contact-required-phone",
    title: "Nuevo dato obligatorio",
    message:
      "Al generar un contacto desde Ventas o Consultas, el email dejó de ser obligatorio. El dato obligatorio ahora es el celular. Recordá siempre solicitarlo.",
    icon: "mobile-alt",
    pack: "fas",
    color: "#02758f",
  },
];
